<template>
  <div></div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "performance",
});
</script>
